export default {
	NO_FILTER_VALUE: 'Select date',
	TITLE: 'Select a date range',
	INFINITE: '∞',
	NO_REDUX_KEY: 'No redux key specified!',
	NO_COLUMN_ID: 'No column id specified!',
};
